import classnames from "classnames";
import React from "react";
import { useRouter } from "next/router";
import { trackMonetateEvent } from "@/context/MonetateContext";
import { OrdersOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/OrdersOutlined";

import styles from "./contact-email.module.scss";

function ContactEmail({ className }) {
  const router = useRouter();

  const handleEmailUsButtonClick = () => {
    trackMonetateEvent("email_contact_rate");
    if (router?.query?.dt === "problemsWithProduct-other") router.push("/email-us?t=problemsWithProduct-problemsOther");
    else router.push("/email-us?t=deliveryQuery-damagedOnDeliveryNonFurniture-online");
  };

  return (
    <div className={classnames(className, styles["contact-email"])} data-test="container-email">
      <h4 className={styles["contact-email-us__title"]}>Use our online form</h4>
      <p>1. Submit your photos using our online form</p>
      <p>2. We’ll be in touch to explain what to do next</p>
      <p>3. This usually includes a quick call with our team</p>
      <button
        type="button"
        className={classnames(styles["email-us-button"])}
        data-test="email-us-button"
        onClick={handleEmailUsButtonClick}
      >
        <span className={styles.emailIcon}>
          <OrdersOutlined />
          Use online form
        </span>
      </button>
    </div>
  );
}

export default ContactEmail;
